"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
export default function MeetTheTeam() {
  const {
    ref: groupPhotoRef,
    isVisible: groupPhotoVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: member1Ref,
    isVisible: member1Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: member2Ref,
    isVisible: member2Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: member3Ref,
    isVisible: member3Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const teamMembers = [{
    name: "Ramin Heydarpour",
    role: "Founder & Managing Partner",
    credential: "Over 20 years of experience in materials science and product innovation.",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/04/RH.jpg?v=d2vcd1jbloh"
  }, {
    name: "Ram Santhanam",
    role: "Managing Director of R&D Services",
    credential: "Specializes in rapid prototyping and manufacturing processes.",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/RS.png?v=29sph9bf81y"
  }, {
    name: "James Johnson",
    role: "Managing Director of Product Services",
    credential: "Expert in intellectual property law and strategic patent portfolios.",
    image: "https://famous-marmoset.10web.cloud/wp-content/uploads/2026/04/JJ2.jpg?v=rzmx8j16fa"
  }];
  const memberRefs = [member1Ref, member2Ref, member3Ref];
  const memberVisibility = [member1Visible, member2Visible, member3Visible];
  return <section className="bg-light-background py-16 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 text-center">
          <h2 className="font-sans text-4xl font-bold text-foreground-light">
            Meet the Team
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={groupPhotoRef} className={`flex items-center justify-center transition-opacity duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${groupPhotoVisible ? "opacity-100" : "opacity-0"}`}>
            <div className="w-full overflow-hidden rounded-lg shadow-medium">
              <img src="https://famous-marmoset.10web.cloud/wp-content/uploads/2026/05/Team_hero.png" alt="Flex DPS Team Group" className="h-auto w-full object-cover" />
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center gap-8">
            {teamMembers.map((member, i) => <div key={i} data-index={i} ref={memberRefs[i]} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${memberVisibility[i] ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="card transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                  <CardContent className="flex items-center gap-4 p-6">
                    <SafeHydrate><Avatar className="size-16 shrink-0">
                      <AvatarImage src={member.image} alt={member.name} />
                      <AvatarFallback className="bg-primary-light text-foreground font-semibold">
                        {member.name.split(" ").map(n => n[0]).join("")}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="flex flex-col gap-1">
                      <h3 className="font-sans text-lg font-semibold text-foreground-light">
                        {member.name}
                      </h3>
                      <p className="text-sm text-muted">{member.role}</p>
                    </div>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}